// import clone from 'clone';
import actions from './actions';
const initState = {  
  assetparts:[],
  isDelete:false,
};

export default function cardReducer(state = initState, { type, ...action }) {
  switch (type) {
    case actions.GET_ASSET_PARTS_REDUCER: {
      return {
        ...state,
        assetparts: action.data,      
        isDelete:false
      };
    }
    default:
      return state;
  }
}
